import { createListenerMiddleware } from '@reduxjs/toolkit';

import { addMessage, removeMessage } from '@appblocks/frontend/redux/messagesSlice';
import { getProjectCode, projectSetDebugTarget } from '@appblocks/frontend/redux/projectSlice';
import { setPageProperty, setSelectedFeature } from '@appblocks/frontend/redux/pagesSlice';

import ProjectInstance from '@appblocks/frontend/client/ProjectInstance';
import FeatureUtils from '@appblocks/codegeneration/FeatureUtils';
import { axiosInstance, API_CODY_URL } from '@appblocks/frontend/client/utils';

const messageTimeouts = {};

const messagesMiddleware = createListenerMiddleware();
messagesMiddleware.startListening({
    actionCreator: addMessage,
    effect: async (action, store) => {
        const message = action.payload;
        if (message.delay !== undefined && message.delay > 0) {
            messageTimeouts[message.id] = setTimeout(() => {
                store.dispatch({
                    type: 'messages/removeMessage',
                    payload: message.id,
                });
            }, message.delay);
        }
    },
});

messagesMiddleware.startListening({
    actionCreator: removeMessage,
    effect: async (action, store) => {
        const messageId = action.payload;
        if (messageTimeouts[messageId]) {
            clearTimeout(messageTimeouts[messageId]);
            delete messageTimeouts[messageId];
        }
    },
});

const pagesMiddleware = createListenerMiddleware();
pagesMiddleware.startListening({
    actionCreator: setPageProperty,
    effect: async (action, store) => {
        const { page, property, value } = action.payload;
        if (property === 'tutorial') {
            if (value === null) {
                localStorage.removeItem(`cody_tutorial_${page}`);
            } else {
                localStorage.setItem(`cody_tutorial_${page}`, true);
            }
        }
    },
});

pagesMiddleware.startListening({
    actionCreator: setSelectedFeature,
    effect: async (action, store) => {
        const featureId = action.payload;
        if (!featureId) {
            return;
        }
        const project = ProjectInstance.getInstance();
        let feature = project.getFeature(featureId);
        if (featureId.indexOf('_widget') > -1) {
            if (featureId.indexOf('lcd_') > -1) {
                feature = project.getFeature('lcd');
            } else {
                feature = project.getFeature('web_dashboard');
            }
        }
        if (feature === undefined) {
            feature = project.getParentFeature(featureId);
        }
        let parent;
        let targetFeatureId;
        let editedFeatures = [];
        if (feature !== undefined) {
            parent = project.getParent(feature);
        }
        while (parent) {
            editedFeatures.push(feature.getID());
            feature = parent;
            parent = project.getParent(feature);
        }
        if (feature) {
            targetFeatureId = feature.getID();
        } else {
            feature = FeatureUtils.getCodeItem(featureId, project);
        }
        for (let i = 0; i < project.features.length; i++) {
            const tmpFeature = project.features[i];
            for (let j = 0; j < tmpFeature.settings.length; j++) {
                if (tmpFeature.settings[j].settingType === 'array' && tmpFeature.settings[j].refId === featureId) {
                    feature = tmpFeature;
                    targetFeatureId = feature.getID();
                    break;
                }
            }
        }
        let targetStep;
        let pageName = 'features';
        const hasError = store.getState().projectData.featureErrors[targetFeatureId] !== undefined;
        if (feature) {
            let shouldCenter;
            let selectedFeature = targetFeatureId;
            if (feature.featureType === 'tibbit'
                || feature.id === 'boardsetting'
                || feature.id === 'wireless_module'
                || feature.featureType === 'peripheral'
            ) {
                targetStep = 0;
                pageName = 'hardware';
                editedFeatures = [feature.getID()];
                selectedFeature = feature.getID();
                if (feature.id === 'boardsetting') {
                    editedFeatures = [];
                    selectedFeature = null;
                }
            } else if (feature.id.indexOf('node_') === 0) {
                targetStep = 2;
                pageName = 'appblocks';
                shouldCenter = hasError;
            } else {
                targetStep = 1;
                pageName = 'features';
            }
            if (targetStep !== undefined) {
                store.dispatch({
                    type: 'pages/setCurrentStep',
                    payload: targetStep,
                });
                store.dispatch({
                    type: 'pages/setPageFeature',
                    payload: {
                        page: pageName,
                        selectedFeature,
                        shouldCenter,
                        editedFeatures: editedFeatures.reverse(),
                    },
                });
                store.dispatch({
                    type: 'pages/setShowErrors',
                    payload: false,
                });
            }
        }
    },
});

const projectsMiddleware = createListenerMiddleware();


/*
let newData = action.payload;
const lines = newData.split('\n');
const errorRegex = /([a-zA-Z0-9_-]+\.tb[s|h])(\(\d+\)):\serror\sC[0-9]+:/gm;
for (let i = 0; i < lines.length; i++) {
    console.log(lines[i]);
    const line = lines[i];
    const match = errorRegex.exec(line);
    if (match !== null) {
        const file = match[1];
        const line = match[2];
        console.log();
    }
}
*/

export {
    messagesMiddleware,
    pagesMiddleware,
    projectsMiddleware,
};
